import { useTranslation } from 'react-i18next';
import { categories } from '@/mocks/categories';

export default function CategoryButtons() {
  const { t } = useTranslation();

  return (
    <section className="py-16 md:py-20 bg-white">
      <div className="px-4 md:px-6">
        <div className="max-w-6xl mx-auto">
          <div className="text-center mb-10">
            <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-900 mb-3">
              Categorias Populares
            </h2>
            <p className="text-foreground-600 max-w-2xl mx-auto text-sm md:text-base">
              Explore as categorias mais procuradas e encontre produtos organizados de forma prática no CSSBuy Spreadsheet.
            </p>
          </div>

          <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-7 gap-3 mb-10">
            {categories.map((cat) => (
              <a
                key={cat.key}
                href={cat.url}
                target="_blank"
                rel="noopener nofollow"
                className="group flex flex-col items-center p-2 bg-background-50 rounded-lg border border-background-200/70 hover:border-primary-300 hover:bg-primary-50 transition-all cursor-pointer text-center overflow-hidden"
              >
                <div className="w-full h-20 md:h-24 mb-2 rounded-md overflow-hidden">
                  <img
                    src={cat.image}
                    alt={cat.label}
                    className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-300"
                  />
                </div>
                <span className="text-xs font-medium text-foreground-700 group-hover:text-primary-700 leading-tight">
                  {cat.label}
                </span>
              </a>
            ))}
          </div>

          <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
            <a
              href="https://kaspreadsheet.com"
              target="_blank"
              rel="noopener nofollow"
              className="inline-flex items-center gap-2 bg-primary-500 text-white font-medium px-8 py-3 rounded-lg hover:bg-primary-600 transition-colors whitespace-nowrap cursor-pointer"
            >
              CSSBuy Spreadsheet
              <i className="ri-external-link-line" />
            </a>
            <a
              href="https://kaspreadsheet.com"
              target="_blank"
              rel="noopener nofollow"
              className="inline-flex items-center gap-2 bg-accent-500 text-white font-medium px-8 py-3 rounded-lg hover:bg-accent-600 transition-colors whitespace-nowrap cursor-pointer"
            >
              Buy It Now
              <i className="ri-shopping-cart-line" />
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}